/**
 * 공통 UI 문자열 리소스
 * 여러 UI에서 공유되는 버튼, 라벨, 메시지
 */
export const commonStr = {
  button: {
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    add: '추가',
    edit: '수정',
    select: '선택',
    close: '닫기',
    confirm: '확인',
    refresh: '새로고침',
    exit: '종료',
    doNotSave: '저장하지 않음',
    apply: '적용',
  },
  dict: {
    position: '포지션',
  },
  label: {
    all: '전체',
    none: '없음',
    search: '검색',
    name: '이름',
    description: '설명',
    condition: '조건',
    reference: '참조',
  },
  message: {
    askDelete: '을(를) 삭제하시겠습니까?',
    confirmDelete: '삭제하시겠습니까?',
    deleted: '삭제되었습니다.',
    requireRestart: '봇 중지 후 재시작이 필요합니다.',
    saved: '저장되었습니다.',
    saveSettingFirst: '변경된 설정 값을 저장해주세요.',
    waitSaving: '저장 중입니다. 잠시 기다려주세요...',
    warningDeleteIndicator: '주의!!!! 삭제될 지표를 참조하는 다음 조건들도 같이 삭제됩니다.',
  },
  tooltip: {
    darkModeToggle: '다크모드 토글',
    settings: '환경설정',
  },
  positionButton: {
    enterableAmount: '진입 가능액의',
    autoAmountEnter: '추가 진입',
    holdingAmount: '보유량의',
  },
  indicatorPicker: {
    title: '지표 선택',
  },
  bottomPanel: {
    tab: {
      order: '거래 내역',
      log: '로그',
    },
    log: {
      no: 'No',
      message: '로그',
      timestamp: '시간',
    },
    tradeSummary: {
      started: '시작',
      elapsed: '경과',
      seed: '씨드',
      summaryType: '집계 기준:',
      enterExit: '진입/청산',
      positionEnd: '포지션 종료',
      mixed: '혼합',
      profit: '수익',
      tradeFee: '수수료',
      netPnl: '순익',
      netRoe: '순익률',
      position: '포지션',
      win: '승',
      lose: '패',
      winRate: '승률',
      profitAmount: '수익액',
      lossAmount: '손실액',
      profitLossRatio: '손익비',
      enter: '진입',
      exit: '청산',
      realizedNetPnl: '실현순익',
    },
    orderHistory: {
      symbol: '종목',
      startDate: '시작일',
      endDate: '종료일',
      showSymbolOnChart: '차트에 이 종목 표시',
      moveToTimeOnChart: '차트에서 이 시간으로 이동',
    },
  },
  validation: {
    enterNumber: '숫자를 입력하세요.',
    rangeNumber: '{min} ~ {max} 사이의 숫자를 입력하세요.',
  },
};
